// global variables
var search_delay = '';
var map_select_opened = false;
var cookie_domain = null;
var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Product = OCS.Product || {};
// functions

OCS.Functions.is_ie = function () {
    return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null)));
};
OCS.Functions.is_edge = function () {
    return (new RegExp("Edge").exec(navigator.userAgent) !== null);
};

OCS.Functions.get_image = function (element, ops) {
    return new OCS.Product.Image(element, ops);
};

// retrieves cookie based on name provided. If none, returns null.
function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value !== null) ? unescape(value[1]) : null;
}
OCS.Functions.getCookie = getCookie;

// Commonly used events. Particularly to be used for IE and Edge
function on_mouse_over(event) {
    event.target.fireEvent('mouseenter', event);
}
function on_mouse_out(event) {
    event.target.fireEvent('mouseleave', event);
}

function init_search() {
    $("#keywords").keyup(function (e) {
        if (e.keyCode === 13) {
            process_search();
        } else {
            if (search_delay) {
                clearTimeout(search_delay);
            }
            search_delay = setTimeout(process_search, 750);
        }

    });
    $("#searchform").submit(function () {
        return false;
    });
    $("html").click(function () {
        $("#search_recommendations").fadeOut(function () {
            $("#search_recommendations").html('<center><img src="//common.mesonet.org/common/db/library/js/classes/colorbox/images/loading.gif" style="padding: 20px"></center>');
        });
    });

    $("#keywords").focus(function (e) {
        $("#keywords").val('');
        $("#keywords").css('color', 'black');
    });
    $("#keywords").blur(function (e) {
        $("#keywords").val('  Search');
        $("#keywords").css('color', '#cccccc');
    });
}
OCS.Functions.init_search = init_search;


function init_site_select_button(page) {
    document.addEventListener("DOMContentLoaded", function (event) {
        if (!page) {
            page = 'forecast';
        }
        var map_select_openend = false;
        var orig_site_select_window = $('#site_select_window');
        var site_select_window = $('#site_select_window').clone();
        $('#site_select_window').find('img').attr('usemap', '');
        site_select_window.find('img').attr('usemap', '#Current_obs_map');
        var method_callback;
        if (OCS.Settings.find_sites_callback && typeof window[OCS.Settings.find_sites_callback] === "function") {
            method_callback = window[OCS.Settings.find_sites_callback];
        }


        $('#' + OCS.Settings.site_select_opener).off('click').on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                width: "740px",
                height: "440px",
                inline: true,
                href: site_select_window,
                opacity: 0.85,
                onComplete: function () {
                    $('#zip', site_select_window).keyup(function (e) {
                        if (e.keyCode == 13) {
                            SS.find_sites_SS(page, method_callback, site_select_window);
                        } else {
                            if (search_delay) {
                                clearTimeout(search_delay);
                            }
                            search_delay = setTimeout(function () {
                                SS.find_sites_SS(page, method_callback, site_select_window);
                            }, 500);
                        }

                    });
                    $("#site_select_form", site_select_window).submit(function () {
                        return false;
                    });
                    $("#zip", site_select_window).focus();
                    SS.find_sites_SS(page, method_callback, site_select_window);
                    SS.set_map_tooltips_SS();
                },
                onOpen: function () {
                    map_select_opened = true;
                },
                onClosed: function () {
                    map_select_opened = false;
                }
            });
        });
        $('#Current_obs_map area', site_select_window).off('click').on('click', function (e) {
            e.preventDefault();
            OCS.Settings.image_map_callback($(this).attr('stid'));
            if (map_select_opened) {
                $('#zip', site_select_window).val('');
                $.colorbox.close();
            }
        });
    });
}

function process_search() {
    if ($("#keywords").val().length < 1 || $("#keywords").val() === '  Search') {
        $("#search_recommendations").fadeOut(function () {
            $("#search_recommendations").html('<center><img src="//common.mesonet.org/common/db/library/js/classes/colorbox/images/loading.gif" style="padding: 20px"></center>');
        });
    } else {
        if ($("#keywords").val().length > 2) {
            $("#search_recommendations").fadeIn();
            vars = $("#searchform").serialize();

            $.post("/index.php/search/recommendations/", vars, function (data) {
                $("#search_recommendations").html(data);
                $(".recommend_item").click(function () {
                    link = $(this).attr('link');
                    document.location.href = link;
                });
            });
        }

    }
}
OCS.Functions.process_search = process_search;

function set_site_select_button(page) {
    $('#site_button_home').on('click', function (e) {
        e.preventDefault();
        $.colorbox({
            width: "740px",
            height: "440px",
            href: '/index.php/site/site_select/',
            opacity: 0.85,
            onComplete: function () {
                $("#zip").keyup(function (e) {
                    if (e.keyCode === 13) {
                        find_sites(page);
                    } else {
                        if (search_delay) {
                            clearTimeout(search_delay);
                        }
                        search_delay = setTimeout("find_sites('" + page + "')", 500);
                    }

                });
                $("#site_select_form").submit(function () {
                    return false;
                });
                $("#zip").focus();
                find_sites(page);
                set_map_tooltips();
            },
            onOpen: function () {
                map_select_opened = true;
            },
            onClosed: function () {
                map_select_opened = false;
            }
        });
    });
}



function set_meteogram_site() {
    save_local_stid(stid);
    document.location.href = '/index.php/weather/meteogram/' + stid;
}

function set_local_page() {
    save_local_stid(stid);
    document.location.href = '/index.php/weather/local/' + stid;
}

function set_forecast_page() {
    save_local_stid(stid);
    document.location.href = '/index.php/forecast/local_and_regional/' + stid;
}

function set_soil_moisture_page() {
    save_local_stid(stid);
    document.location.href = '/index.php/weather/soil_moisture/' + stid;
}

function set_soil_temperature_page() {
    save_local_stid(stid);
    document.location.href = '/index.php/weather/soil_temperature/' + stid;
}

function set_okfire_page(newstid, num) {
    if (num == 1) {
        save_local_stid(newstid);
    } else {
        save_local_stid2(newstid);
    }

    document.location.href = '/index.php/okfire/home';
}
OCS.Functions.set_okfire_page = set_okfire_page;

function set_okfire_current_conditions_page(newstid) {
    document.location.href = '/index.php/okfire/current_station_conditions/' + newstid;
}

function set_soil_moisture_duration(days) {
    document.location.href = '/index.php/weather/soil_moisture/' + stid + "/" + days;
}

function set_soil_temperature_duration(days) {
    document.location.href = '/index.php/weather/soil_temperature/' + stid + "/" + days;
}

function save_local_stid(stid) {
    $.cookie("stid", stid, {domain: get_cookie_domain(), path: '/', expires: 30});
}

function save_local_stid2(stid) {
    $.cookie("stid2", stid, {domain: get_cookie_domain(), path: '/', expires: 30});
}

function save_local_regionid(regionid) {
    $.cookie("regionid", regionid, {domain: get_cookie_domain(), path: '/', expires: 30});
}

function save_show_legend(state) {
    $.cookie("show_legend", state, {domain: get_cookie_domain(), path: '/', expires: 30});
}

function get_show_legend() {
    return $.cookie('show_legend') === null ? true : $.cookie('show_legend');
}

function find_sites(page) {
    if ($("#zip").val().length < 1) {
        $.post("/index.php/site/site_select_results/", function (data) {
            $("#site_results").html(data);
            $(".stid_link").on('click', function () {
                stid = $(this).attr('stid').toLowerCase();
                if (page === 'local') {
                    set_local_page();
                } else if (page === 'soil_moisture') {
                    set_soil_moisture_page();
                } else if (page === 'forecast') {
                    set_forecast_page();
                } else if (page === 'meteogram') {
                    set_meteogram_site();
                } else if (page === 'station_monthly_summaries') {
                    $("[name=stid]").val(stid.toUpperCase());
                } else if (page == 'okfire1') {
                    var paramPage = this.href;
                    var isCurrentCond = paramPage.includes("current_station_conditions");
                    if (isCurrentCond === true) {
                        set_okfire_current_conditions_page(stid);
                    } else {
                        set_okfire_page(stid, 1);
                    }
                } else if (page == 'okfire2') {
                    set_okfire_page(stid, 2);
                } else {
                    set_current_box();
                }
                $.fn.colorbox.close();
            });
        });
    } else {
        if ($("#zip").val().length > 2) {
            vars = $("#site_select_form").serialize();
            $.post("/index.php/site/site_select_results/", vars, function (data) {
                $("#site_results").html(data);
                $(".stid_link").on('click', function () {
                    stid = $(this).attr('stid').toLowerCase();
                    if (page === 'local') {
                        set_local_page();
                    } else if (page === 'soil_moisture') {
                        set_soil_moisture_page();
                    } else if (page === 'forecast') {
                        set_forecast_page();
                    } else if (page === 'meteogram') {
                        set_meteogram_site(stid);
                    } else if (page === 'station_monthly_summaries') {
                        $("[name=stid]").val(stid.toUpperCase());
                    } else if (page == 'okfire1') {
                        set_okfire_page(stid, 1);
                    } else if (page == 'okfire2') {
                        set_okfire_page(stid, 2);
                    } else {
                        set_current_box();
                    }

                    $.fn.colorbox.close();
                });
            });
        }
    }
}
OCS.Functions.find_sites = find_sites;

function set_map_tooltips() {
    $('.current_obs_map area').each(function () {
        $(this).qtip({
            content: {
                text: $(this).attr('alt'),
                title: $(this).attr('toolTipTitle')
            }, // Use the ALT attribute of the area map
            show: {
                solo: true
            },
            position: {
                my: 'bottom left', // Position my bottom left...
                at: 'top right', // at the top right of...
                adjust: {
                    screen: true
                }
            }
        });
        $(this).qtip("focus");
    });
}
OCS.Functions.set_map_tooltips = set_map_tooltips;

function image_refresh(image, obj) {
    timestamp = new Date().getTime();
    $("." + obj).attr("src", image + "?" + timestamp);
}

/**
 * Set the Cookie Domain to the current domain and all subdomains
 * We check to see if the http_host is a testing domain (starts with "x")
 * and if not, then we determine how to set the other.
 * For a HTTP_HOST of x.y.z
 *   if z is "org" or "us", then the domain should be y.z
 *   if z is "gov" or "edu", then the domain should be x.y.z
 */
function get_cookie_domain() {
    var domain = window.location.host;
    if (cookie_domain) {
        return cookie_domain;
    } else {
        var url = domain;
        var matches = url.match(/([a-zA-Z0-9\-]+\.)?([a-zA-Z0-9\-]+)\.(org|us|local|gov|edu)/i);
        if (matches[3] === 'org' || matches[3] === 'us' || matches[3] === 'local') {
            domain = matches[2] + '.' + matches[3];
        } else if (matches[3] === 'gov' || matches[3] === 'edu') {
            domain = matches[1] + matches[2] + '.' + matches[3];
        }
    }
    return domain;
}
OCS.Functions.get_cookie_domain = get_cookie_domain;

/**
 * hoverIntent r6 // 2011.02.26 // jQuery 1.5.1+
 * <http://cherne.net/brian/resources/jquery.hoverIntent.html>
 *
 * @param  f  onMouseOver function || An object with configuration options
 * @param  g  onMouseOut function  || Nothing (use configuration options object)
 * @author    Brian Cherne brian(at)cherne(dot)net
 */
(function ($) {
    $.fn.hoverIntent = function (f, g) {
        var cfg = {sensitivity: 7, interval: 100, timeout: 0};
        cfg = $.extend(cfg, g ? {over: f, out: g} : f);
        var cX, cY, pX, pY;
        var track = function (ev) {
            cX = ev.pageX;
            cY = ev.pageY
        };
        var compare = function (ev, ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            if ((Math.abs(pX - cX) + Math.abs(pY - cY)) < cfg.sensitivity) {
                $(ob).unbind("mousemove", track);
                ob.hoverIntent_s = 1;
                return cfg.over.apply(ob, [ev])
            } else {
                pX = cX;
                pY = cY;
                ob.hoverIntent_t = setTimeout(function () {
                    compare(ev, ob)
                }, cfg.interval)
            }
        };
        var delay = function (ev, ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            ob.hoverIntent_s = 0;
            return cfg.out.apply(ob, [ev])
        };
        var handleHover = function (e) {
            var ev = jQuery.extend({}, e);
            var ob = this;
            if (ob.hoverIntent_t) {
                ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t)
            }
            if (e.type == "mouseenter") {
                pX = ev.pageX;
                pY = ev.pageY;
                $(ob).bind("mousemove", track);
                if (ob.hoverIntent_s != 1) {
                    ob.hoverIntent_t = setTimeout(function () {
                        compare(ev, ob)
                    }, cfg.interval)
                }
            } else {
                $(ob).unbind("mousemove", track);
                if (ob.hoverIntent_s == 1) {
                    ob.hoverIntent_t = setTimeout(function () {
                        delay(ev, ob)
                    }, cfg.timeout)
                }
            }
        };
        return this.bind('mouseenter', handleHover).bind('mouseleave', handleHover)
    }
})(jQuery);


/*
 
 -- -- -- -- -- -- --
 css sprites 2
 nav behaviour
 
 http://www.alistapart.com/articles/sprites2
 -- -- -- -- -- -- --
 
 */

function generateSprites(parent, selectedPrefix, setActive, hoverSpeed, style) {
    // throw the parent object's class into a variable
    var parentClass = $(parent).attr("class");

    // start a loop that cycles through each of the li elements inside the parent element
    $(parent).children("li").each(function () {
        // create a few variables that we'll need during this function:
        // myClass = the class of the object we're currently inspecting
        // current = what the selected class should look like for the parent of the object we're currently inspecting
        var myClass = ($(this).attr("class"))
        var current = parent.substring(1) + " current-" + ($(this).attr("class"));

        // turn on nav events for element this loop identifies
        attachNavEvents(parent, myClass, setActive, hoverSpeed, style);

        // let's hide the CSS-defined background image, but only if this isn't the currently-selected item
        if (parentClass != current) {
            $(this).children("a").css({backgroundImage: "none"});
        }

    });
}
OCS.Functions.generateSprites = generateSprites;


function attachNavEvents(parent, myClass, setActive, hoverSpeed, style) {
    $(parent + " ." + myClass).mouseover(function () {
        // create pseudo-link
        $(this).append('<div class="nav-' + myClass + '"></div>');
        // either slide or fade, depending on the style value
        if (style == "slide") {
            // slide down the pseudo-link
            $("div.nav-" + myClass).css({display: "none"}).slideDown(hoverSpeed);
        } else {
            // fade in the pseudo-link
            $("div.nav-" + myClass).css({display: "none"}).fadeIn(hoverSpeed);
        }
    }).mouseout(function () {
        // either slide or fade, depending on the style value
        if (style == "slide") {
            // slide up & destroy pseudo-link
            $("div.nav-" + myClass).slideUp(hoverSpeed, function () {
                $(this).remove();
            });
        } else {
            // fade out & destroy pseudo-link
            $("div.nav-" + myClass).fadeOut(hoverSpeed, function () {
                $(this).remove();
            });
        }
    });


    // we only want to check the mousedown/up events if the CSS exists for :active states
    // if so, let's apply our selective filtering to undo the events above
    if (setActive) {
        $(parent + " ." + myClass).mousedown(function () {
            $("div.nav-" + myClass).attr("class", "nav-" + myClass + "-click");
        }).mouseup(function () {
            $("div.nav-" + myClass + "-click").attr("class", "nav-" + myClass);
        });
    }
}
